import Mixpanel from '@Helpers/mixpanel';
import { selectEnvironment } from '@Helpers/util';
import {
  VERTICAL_TIERS_LOADED,
  VERTICAL_TIERS_CLEAR,
  CUSTOMER_SUBSCRIPTION_LOADED,
  CUSTOMER_SUBSCRIPTION_CLEAR,
  ONBOARDING_PRICING_LOADED,
  ONBOARDING_PRICING_CLEAR,
  ONBOARDING_SUBMISSION_SUCCESS,
  ONBOARDING_SUBMISSION_CLEAR,
  ONBOARDING_PROVISIONING_SUCCESS,
  ONBOARDING_PROVISIONING_CLEAR,
  CUSTOMER_ONBOARDING_DATA_LOADED,
  CUSTOMER_ONBOARDING_DATA_CLEAR,
  CUSTOMER_ONBOARDING_DATA_LOADING,
  CANCELLATION_STATUS_LOADED,
  PLAN_MANAGEMENT_LOADING,
  PLAN_MANAGEMENT_LOADED,
  PLAN_MANAGEMENT_CLEAR,
  PLAN_UPGRADE_SUCCESS,
  PLAN_UPGRADE_CLEAR,
  PREFILL_ONBOARDING_DATA_LOADING,
  PREFILL_ONBOARDING_DATA_LOADED,
  PREFILL_ONBOARDING_DATA_CLEAR,
  PAYOUT_STATUS_LOADING,
  PAYOUT_STATUS_LOADED,
  PAYOUT_STATUS_CLEAR,
  PAYOUT_ACCOUNT_LOADING,
  PAYOUT_ACCOUNT_LOADED,
  PAYOUT_ACCOUNT_CLEAR,
} from './actionTypes';
import * as api from './apiHelper';
import { initiateRedirectRequest } from './redirectActions';
import {
  setFetchLoaderLoading,
  setFetchLoaderReset,
  setSubmissionLoaderLoading,
  setSubmissionLoaderReset,
} from './fetchLoaderActions';
import { arriveNotice, arriveCustomNotice } from './noticeActions';


export function verticalTiersLoaded(verticalTiers) {
  return {
    type: VERTICAL_TIERS_LOADED,
    payload: { verticalTiers },
  };
}

export function verticalTiersClear() {
  return { type: VERTICAL_TIERS_CLEAR };
}

export function customerSubscriptionLoaded(subscription) {
  return {
    type: CUSTOMER_SUBSCRIPTION_LOADED,
    payload: { subscription },
  };
}

export function customerSubscriptionClear() {
  return { type: CUSTOMER_SUBSCRIPTION_CLEAR };
}

export function cancellationStatusLoaded(
  cancellationRequestedAt,
  effectiveCancellationDate,
  ghlScheduleCancelledAt,
) {
  return {
    type: CANCELLATION_STATUS_LOADED,
    payload: { cancellationRequestedAt, effectiveCancellationDate, ghlScheduleCancelledAt },
  };
}

export function customerOnboardingDataLoaded(onboardingData) {
  return {
    type: CUSTOMER_ONBOARDING_DATA_LOADED,
    payload: { onboardingData },
  };
}

export function customerOnboardingDataClear() {
  return { type: CUSTOMER_ONBOARDING_DATA_CLEAR };
}

export function customerOnboardingDataLoading(isLoading) {
  return {
    type: CUSTOMER_ONBOARDING_DATA_LOADING,
    payload: { isLoading },
  };
}

export function onboardingPricingLoaded(pricing) {
  return {
    type: ONBOARDING_PRICING_LOADED,
    payload: { pricing },
  };
}
export function onboardingPricingClear() {
  return { type: ONBOARDING_PRICING_CLEAR };
}

export function onboardingSubmissionSuccess(response) {
  return {
    type: ONBOARDING_SUBMISSION_SUCCESS,
    payload: { response },
  };
}

export function onboardingSubmissionClear() {
  return { type: ONBOARDING_SUBMISSION_CLEAR };
}

export function onboardingProvisioningSuccess(response) {
  return {
    type: ONBOARDING_PROVISIONING_SUCCESS,
    payload: { response },
  };
}

export function onboardingProvisioningClear() {
  return { type: ONBOARDING_PROVISIONING_CLEAR };
}

export function prefillOnboardingDataLoadingAction(isLoading) {
  return { type: PREFILL_ONBOARDING_DATA_LOADING, payload: { isLoading } };
}

export function prefillOnboardingDataLoaded(data) {
  return { type: PREFILL_ONBOARDING_DATA_LOADED, payload: { data } };
}

export function prefillOnboardingDataClear() {
  return { type: PREFILL_ONBOARDING_DATA_CLEAR };
}

export function payoutStatusLoaded(payoutStatus) {
  return {
    type: PAYOUT_STATUS_LOADED,
    payload: { payoutStatus },
  };
}

export function payoutStatusClear() {
  return { type: PAYOUT_STATUS_CLEAR };
}

export function payoutStatusLoading(isLoading) {
  return {
    type: PAYOUT_STATUS_LOADING,
    payload: { isLoading },
  };
}

export function payoutAccountLoaded(payoutAccount) {
  return {
    type: PAYOUT_ACCOUNT_LOADED,
    payload: { payoutAccount },
  };
}

export function payoutAccountClear() {
  return { type: PAYOUT_ACCOUNT_CLEAR };
}

export function payoutAccountLoading(isLoading) {
  return {
    type: PAYOUT_ACCOUNT_LOADING,
    payload: { isLoading },
  };
}

// API
async function fetchOnboardingPricingApi() {
  const response = await api.get({
    path: 'common/customer-onboardings/pricing',
    token: null,
    version: 'gateway',
  });
  return response.json();
}

async function submitOnboardingApi(body) {
  const response = await api.post({
    path: 'common/customer-onboardings',
    token: null,
    body,
    version: 'gateway',
  });
  return response.json();
}

async function provisionOnboardingApi(onboardingId) {
  const response = await api.post({
    path: `common/customer-onboardings/${onboardingId}/provision`,
    token: null,
    version: 'gateway',
  });
  return response.json();
}

async function getCustomerOnboardingDataApi(onboardingId, token) {
  const response = await api.get({
    path: `common/customer-onboardings/${onboardingId}`,
    token,
    version: 'gateway',
  });
  return response.json();
}

async function fetchPrefillOnboardingDataApi(token) {
  const response = await api.get({
    path: `common/customer-onboardings/prefill/${token}`,
    version: 'gateway',
    token: null,
    customError: true,
  });
  return response;
}

async function getVerticalTiersApi(args) {
  const response = await api.get({
    path: 'subscriptions',
    params: args,
    token: null,
    version: 'v4',
  });
  return response.json();
}

async function getCustomerSubscriptionApi(companyId, args, token) {
  const response = await api.get({
    path: `subscriptions/${companyId}`,
    params: args,
    token,
    version: 'v4',
  });
  return response.json();
}

async function getCancellationStatusApi(token) {
  const response = await api.get({
    path: 'subscriptions/cancellation_status',
    token,
    version: 'v4',
  });
  return response.json();
}

async function createSubscriptionApi(body, dispatch) {
  const response = await api.post({
    path: 'subscriptions',
    body,
    token: null,
    version: 'v4',
    customError: true,
  });

  if (!response.ok) {
    const json = await response.json();

    if (json?.errors) {
      const customError = api.extractErrorMessage(json.errors);
      dispatch(arriveCustomNotice(customError));

      throw customError;
    } else {
      const formattedMessage = api.formatJsonError(json.error);
      const error = new Error(formattedMessage);
      dispatch(arriveNotice(error.message));

      throw error;
    }
  }

  return response.json();
}

async function updateSubscriptionApi(body, token, dispatch) {
  const response = await api.post({
    path: 'subscriptions/update_subscription',
    body,
    token,
    customError: true,
    version: 'v4',
  });

  if (!response.ok) {
    const json = await response.json();

    if (json?.errors) {
      const customError = api.extractErrorMessage(json.errors);
      dispatch(arriveCustomNotice(customError));

      throw customError;
    } else {
      const formattedMessage = api.formatJsonError(json.error);
      const error = new Error(formattedMessage);
      dispatch(arriveNotice(error.message));

      throw error;
    }
  }

  return response.json();
}

async function updatePaymentMethodApi(body, token) {
  const response = await api.patch({
    path: 'subscriptions/update_payment_method',
    body,
    token,
    version: 'v4',
  });
  return response.json();
}

async function createCancellationRequestApi(body, token, dispatch) {
  const response = await api.post({
    path: 'subscriptions/create_cancellation_request',
    body,
    token,
    customError: true,
    version: 'v4',
  });

  if (!response.ok) {
    const json = await response.json();
    if (json?.errors) {
      const customError = api.extractErrorMessage(json.errors);
      dispatch(arriveCustomNotice(customError));
      throw customError;
    } else {
      const formattedMessage = api.formatJsonError(json.error);
      const error = new Error(formattedMessage);
      dispatch(arriveNotice(error.message));
      throw error;
    }
  }

  return response.json();
}

async function withdrawCancellationRequestApi(token, dispatch) {
  const response = await api.del({
    path: 'subscriptions/withdraw_cancellation_request',
    token,
    customError: true,
    version: 'v4',
  });

  if (!response.ok) {
    const json = await response.json();
    if (json?.errors) {
      const customError = api.extractErrorMessage(json.errors);
      dispatch(arriveCustomNotice(customError));
      throw customError;
    } else {
      const formattedMessage = api.formatJsonError(json.error);
      const error = new Error(formattedMessage);
      dispatch(arriveNotice(error.message));
      throw error;
    }
  }

  return response.json();
}

export async function upsertOnboardingLead({ email, leadId, contact }) {
  /* eslint-disable camelcase */
  const body = { email };
  if (leadId) body.lead_id = leadId;
  if (contact) {
    body.contact = {
      company_name: contact.companyName,
      full_name: contact.fullName,
      phone: contact.phone,
      country: contact.country,
    };
  }
  /* eslint-enable camelcase */
  const response = await api.post({
    path: 'common/customer-onboardings/leads',
    body,
    token: null,
    version: 'gateway',
    customError: true,
  });
  if (!response.ok) {
    const json = await response.json();
    const message = json.message || 'Failed to save your information.';
    const error = new Error(message);
    error.statusCode = response.status;
    throw error;
  }
  const json = await response.json();
  return api.camelizeKeys(json); // { leadId, email, syncedToGhl }
}

export async function checkEarlyBirdEligibility(leadId) {
  const response = await api.post({
    path: `common/customer-onboardings/leads/${leadId}/early-bird`,
    token: null,
    version: 'gateway',
  });
  const json = await response.json();
  return api.camelizeKeys(json); // { eligible, expiresAt, remainingSeconds, reason }
}

async function checkYoutubeCidEligibilityApi(body) {
  const response = await api.post({
    path: 'common/customer-onboardings/youtube-cid/eligibility',
    body,
    token: null,
    version: 'gateway',
    customError: true,
  });

  if (!response.ok) {
    let message = 'Failed to verify YouTube channel eligibility.';
    try {
      const json = await response.json();
      message = json.message || message;
    } catch { /* non-JSON error body */ }
    const error = new Error(message);
    error.statusCode = response.status;
    throw error;
  }

  const json = await response.json();
  return api.camelizeKeys(json);
}

export async function checkYoutubeCidEligibility({ accountType, channels }) {
  Mixpanel.track('onboarding_youtube_eligibility_check_requested', {
    environment: selectEnvironment(),
    accountType,
    channelCount: channels?.length || 0,
  });

  /* eslint-disable camelcase */
  const body = {
    account_type: accountType,
    channels,
  };
  /* eslint-enable camelcase */

  let result;
  try {
    result = await checkYoutubeCidEligibilityApi(body);
  } catch (error) {
    Mixpanel.track('onboarding_youtube_eligibility_check_failed', {
      environment: selectEnvironment(),
      accountType,
      channelCount: channels?.length || 0,
      statusCode: error.statusCode,
    });
    throw error;
  }

  Mixpanel.track('onboarding_youtube_eligibility_check_succeeded', {
    environment: selectEnvironment(),
    accountType,
    channelCount: channels?.length || 0,
    eligible: result?.eligible === true,
    checkApplied: result?.checkApplied === true,
  });
  if (result?.eligible === false) {
    Mixpanel.track('onboarding_youtube_eligibility_check_ineligible', {
      environment: selectEnvironment(),
      accountType,
      channelCount: channels?.length || 0,
    });
  }
  return result;
}

async function createCidOnboardingApi(body, token) {
  const response = await api.post({
    path: 'common/content-owner-onboardings',
    body,
    token,
    version: 'gateway',
  });
  return response.json();
}


async function getPayoutStatusApi(token) {
  const response = await api.get({
    path: 'common/customer-onboarding-payouts/status',
    token,
    version: 'gateway',
  });
  return response.json();
}

async function getPayoutAccountApi(token) {
  const response = await api.get({
    path: 'common/customer-onboarding-payouts/account',
    token,
    version: 'gateway',
  });
  return response.json();
}

async function createPayoutAccountSessionApi(token) {
  const response = await api.post({
    path: 'common/customer-onboarding-payouts/session',
    body: {},
    token,
    version: 'gateway',
    customError: true,
  });
  if (!response.ok) {
    const json = await response.json();
    const message = json?.message || 'Failed to start payout setup. Please try again.';
    throw new Error(message);
  }
  return response.json();
}

async function getPayoutBusinessInfoApi(token) {
  const response = await api.get({
    path: 'common/customer-onboarding-payouts/business-info',
    token,
    version: 'gateway',
  });
  return response.json();
}

async function updatePayoutBusinessInfoApi(body, token) {
  const response = await api.patch({
    path: 'common/customer-onboarding-payouts/business-info',
    body,
    token,
    version: 'gateway',
    customError: true,
  });
  if (!response.ok) {
    const json = await response.json();
    const message = json?.message || 'Failed to save business info. Please try again.';
    throw new Error(message);
  }
  return response.json();
}

async function deletePayoutAccountApi(token) {
  const response = await api.del({
    path: 'common/customer-onboarding-payouts',
    token,
    version: 'gateway',
    customError: true,
  });
  if (!response.ok) {
    const json = await response.json();
    const message = json?.message || 'Failed to unlink payout account. Please try again.';
    throw new Error(message);
  }
  return response.json();
}

// Public components actions
export function initiateCreateSubscriptionRequest(requestBody, stripeInfo, redirectPath) {
  return async (dispatch, getState) => {
    try {
      const { fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());

      const result = await stripeInfo.stripe.createToken(stripeInfo.card);

      if (result.error) {
        dispatch(setSubmissionLoaderReset());
        throw new Error(result.error.message);
      } else {
        const body = { token: result.token.id, ...requestBody };
        await createSubscriptionApi(body, dispatch);

        Mixpanel.track('new_subscription_created', {
          environment: selectEnvironment(),
          ...requestBody,
        });
        dispatch(arriveNotice('Signup successful!', 'ok'));
        dispatch(initiateRedirectRequest(null, redirectPath, true));
        dispatch(setSubmissionLoaderReset());
      }
    } catch (e) {
      dispatch(setSubmissionLoaderReset());
    }
  };
}

export function initiateUpdateSubscriptionRequest(requestBody, redirectPath, isRestore = false) {
  return async (dispatch, getState) => {
    try {
      const { auth: { token }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());

      const isCancel = requestBody.cancel_sub ?? false;

      await updateSubscriptionApi(requestBody, token, dispatch);

      let notice = isCancel ? 'Subscription cancelled successfully' : 'Subscription updated successfully!';

      if (isRestore) {
        notice = 'Subscription restored successfully!';
        Mixpanel.track('subscription_restored', {
          environment: selectEnvironment(),
        });
      } else if (isCancel) {
        Mixpanel.track('subscription_cancelled', {
          environment: selectEnvironment(),
        });
      }

      dispatch(arriveNotice(notice, 'ok'));
      dispatch(initiateRedirectRequest(null, redirectPath, true));
      dispatch(setSubmissionLoaderReset());
    } catch (e) {
      dispatch(setSubmissionLoaderReset());
    }
  };
}

export function initiateUpdatePaymentMethodRequest(stripeInfo, redirectPath) {
  return async (dispatch, getState) => {
    try {
      const { auth: { token }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());

      const result = await stripeInfo.stripe.createToken(stripeInfo.card);

      if (result.error) {
        dispatch(setSubmissionLoaderReset());
        throw new Error(result.error.message);
      } else {
        const body = { token: result.token.id };
        await updatePaymentMethodApi(body, token);

        dispatch(arriveNotice('Payment method updated successfully!', 'ok'));
        dispatch(setSubmissionLoaderReset());
        dispatch(initiateRedirectRequest(null, redirectPath, true));
      }
    } catch (e) {
      dispatch(setSubmissionLoaderReset());
      dispatch(arriveNotice(e.message));
    }
  };
}

export function clearVerticalTiersRequest() {
  return (dispatch) => {
    dispatch(verticalTiersClear());
  };
}

export function fetchVerticalTiersRequest(args) {
  return async (dispatch, getState) => {
    try {
      dispatch(verticalTiersClear());

      const { fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());

      const response = await getVerticalTiersApi(args);

      dispatch(verticalTiersLoaded(response));
      dispatch(setFetchLoaderReset());
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(setFetchLoaderReset());
        dispatch(arriveNotice(e.message));
      }
    }
  };
}

export function clearCustomerSubscriptionRequest() {
  return (dispatch) => {
    dispatch(customerSubscriptionClear());
  };
}

export function fetchCancellationStatus() {
  return async (dispatch, getState) => {
    try {
      const { auth: { token } } = getState();
      const response = await getCancellationStatusApi(token);
      const value = response.cancellationRequestedAt ?? response.cancellation_requested_at ?? null;
      const effectiveDate = response.effectiveCancellationDate
        ?? response.effective_cancellation_date ?? null;
      const ghlCancelledAt = response.ghlScheduleCancelledAt
        ?? response.ghl_schedule_cancelled_at ?? null;
      dispatch(cancellationStatusLoaded(value, effectiveDate, ghlCancelledAt));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[fetchCancellationStatus] failed:', e);
    }
  };
}

export function fetchCustomerSubscriptionRequest(companyId, args) {
  return async (dispatch, getState) => {
    try {
      dispatch(customerSubscriptionClear());

      const { auth: { token }, fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());

      const response = await getCustomerSubscriptionApi(companyId, args, token);
      dispatch(customerSubscriptionLoaded(response));
      dispatch(setFetchLoaderReset());
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(setFetchLoaderReset());
        dispatch(arriveNotice(e.message));
      }
    }
  };
}

export function initiateCreateCidOnboardingRequest(requestBody) {
  return async (dispatch, getState) => {
    try {
      const { auth: { token }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());
      await createCidOnboardingApi(requestBody, token);

      Mixpanel.track('cid_onboarding_submitted', {
        environment: selectEnvironment(),
      });

      dispatch(arriveNotice('Submission successful!', 'ok'));
      dispatch(setSubmissionLoaderReset());
      return true;
    } catch (e) {
      dispatch(setSubmissionLoaderReset());
      dispatch(arriveNotice(e.message));
      return false;
    }
  };
}

export function clearOnboardingPricingRequest() {
  return (dispatch) => {
    dispatch(onboardingPricingClear());
  };
}

export function fetchOnboardingPricingRequest() {
  return async (dispatch, getState) => {
    try {
      const { fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());

      const response = await fetchOnboardingPricingApi();
      const camelResponse = api.camelizeKeys(response);

      dispatch(onboardingPricingLoaded(camelResponse));
      dispatch(setFetchLoaderReset());
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(setFetchLoaderReset());
        dispatch(arriveNotice(e.message));
      }
    }
  };
}

export function clearSubmitOnboardingRequest() {
  return (dispatch) => {
    dispatch(onboardingSubmissionClear());
  };
}

export function initiateSubmitOnboardingRequest(requestBody) {
  return async (dispatch, getState) => {
    try {
      const { fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());

      const response = await submitOnboardingApi(requestBody);
      const camelResponse = api.camelizeKeys(response);

      dispatch(arriveNotice('Submission successful!', 'ok'));
      dispatch(onboardingSubmissionSuccess(camelResponse));
      dispatch(setSubmissionLoaderReset());
    } catch (e) {
      dispatch(setSubmissionLoaderReset());
      dispatch(arriveNotice(e.message));
    }
  };
}

export function clearProvisionOnboardingRequest() {
  return (dispatch) => {
    dispatch(onboardingProvisioningClear());
  };
}

export function initiateProvisionOnboardingRequest(onboardingId, setError) {
  return async (dispatch, getState) => {
    try {
      const { fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());

      const response = await provisionOnboardingApi(onboardingId);
      const camelResponse = api.camelizeKeys(response);

      dispatch(arriveNotice('Account setup successful!', 'ok'));
      dispatch(onboardingProvisioningSuccess(camelResponse));
      dispatch(setSubmissionLoaderReset());
    } catch (e) {
      setError('Account setup failed. Please email our team at contact@redflagai.co to resolve this issue.');
      dispatch(setSubmissionLoaderReset());
      dispatch(arriveNotice(e.message));
    }
  };
}

export function clearCustomerOnboardingData() {
  return (dispatch) => {
    dispatch(customerOnboardingDataClear());
  };
}

export function fetchCustomerOnboardingData(onboardingId) {
  return async (dispatch, getState) => {
    try {
      const { auth: { token } } = getState();
      dispatch(customerOnboardingDataLoading(true));

      const response = await getCustomerOnboardingDataApi(onboardingId, token);
      const camelResponse = api.camelizeKeys(response);

      dispatch(customerOnboardingDataLoaded(camelResponse));
      dispatch(customerOnboardingDataLoading(false));
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(customerOnboardingDataClear());
        dispatch(customerOnboardingDataLoading(false));
        dispatch(arriveNotice(e.message));
      }
    }
  };
}

export function initiateCreateCancellationRequest(reason, onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { auth: { token }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());

      /* eslint-disable camelcase */
      await createCancellationRequestApi({ reason }, token, dispatch);
      /* eslint-enable camelcase */

      dispatch(arriveNotice('Cancellation request submitted successfully.', 'ok'));
      dispatch(setSubmissionLoaderReset());
      if (onSuccess) onSuccess();
    } catch (e) {
      dispatch(setSubmissionLoaderReset());
    }
  };
}

export function planManagementLoaded(planManagementData) {
  return {
    type: PLAN_MANAGEMENT_LOADED,
    payload: { planManagementData },
  };
}

export function planManagementClear() {
  return { type: PLAN_MANAGEMENT_CLEAR };
}

export function planManagementLoading(isLoading) {
  return {
    type: PLAN_MANAGEMENT_LOADING,
    payload: { isLoading },
  };
}

export function planUpgradeSuccess(upgradeResponse) {
  return {
    type: PLAN_UPGRADE_SUCCESS,
    payload: { upgradeResponse },
  };
}

export function planUpgradeClear() {
  return { type: PLAN_UPGRADE_CLEAR };
}

async function getPlanManagementApi(token) {
  const response = await api.get({
    path: 'common/customer-onboardings/plan-management',
    token,
    version: 'gateway',
  });
  return response.json();
}

async function upgradeSocialPlanApi(body, token, dispatch) {
  const response = await api.post({
    path: 'common/customer-onboardings/plan-management/social-upgrade',
    body,
    token,
    version: 'gateway',
    customError: true,
  });

  if (!response.ok) {
    const json = await response.json();
    const message = json?.message || 'Plan upgrade failed. Please try again.';
    const error = new Error(message);
    dispatch(arriveNotice(error.message));
    throw error;
  }

  return response.json();
}

export function initiateWithdrawCancellationRequest(onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { auth: { token }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());

      await withdrawCancellationRequestApi(token, dispatch);

      dispatch(arriveNotice('Cancellation request withdrawn successfully.', 'ok'));
      dispatch(setSubmissionLoaderReset());
      if (onSuccess) onSuccess();
    } catch (e) {
      dispatch(setSubmissionLoaderReset());
    }
  };
}

export function fetchPlanManagement() {
  return async (dispatch, getState) => {
    try {
      const { auth: { token } } = getState();
      dispatch(planManagementLoading(true));

      const response = await getPlanManagementApi(token);
      const camelResponse = api.camelizeKeys(response);

      dispatch(planManagementLoaded(camelResponse));
      dispatch(planManagementLoading(false));
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(planManagementClear());
        dispatch(planManagementLoading(false));
        dispatch(arriveNotice(e.message));
      }
    }
  };
}

export function clearPlanManagement() {
  return (dispatch) => {
    dispatch(planManagementClear());
  };
}

export function clearPlanUpgradeResponse() {
  return (dispatch) => {
    dispatch(planUpgradeClear());
  };
}

export function initiateUpgradeSocialPlanRequest(platforms, signature, onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { auth: { token }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());

      /* eslint-disable camelcase */
      const body = { social_scanning: { platforms }, signature };
      /* eslint-enable camelcase */

      const response = await upgradeSocialPlanApi(body, token, dispatch);
      const camelResponse = api.camelizeKeys(response);

      dispatch(planUpgradeSuccess(camelResponse));
      dispatch(arriveNotice('Plan upgraded successfully!', 'ok'));
      dispatch(setSubmissionLoaderReset());
      if (onSuccess) onSuccess(camelResponse);
    } catch (e) {
      dispatch(setSubmissionLoaderReset());
    }
  };
}

export function fetchPrefillOnboardingDataRequest(token) {
  return async (dispatch) => {
    try {
      dispatch(prefillOnboardingDataLoadingAction(true));
      const response = await fetchPrefillOnboardingDataApi(token);
      if (!response.ok) {
        const json = await response.json();
        const message = json.message || 'Invalid or expired onboarding link.';
        const error = new Error(message);
        error.statusCode = response.status;
        throw error;
      }
      const json = await response.json();
      const camelResponse = api.camelizeKeys(json);
      dispatch(prefillOnboardingDataLoaded(camelResponse));
    } catch (e) {
      if (e.name !== 'AbortError') dispatch(arriveNotice(e.message));
    } finally {
      dispatch(prefillOnboardingDataLoadingAction(false));
    }
  };
}

export function clearPrefillOnboardingDataRequest() {
  return (dispatch) => dispatch(prefillOnboardingDataClear());
}


export function fetchPayoutStatus() {
  return async (dispatch, getState) => {
    try {
      const { auth: { token } } = getState();
      dispatch(payoutStatusLoading(true));

      const response = await getPayoutStatusApi(token);
      const camelResponse = api.camelizeKeys(response);

      dispatch(payoutStatusLoaded(camelResponse));
      dispatch(payoutStatusLoading(false));
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(payoutStatusClear());
        dispatch(payoutStatusLoading(false));
        // No notice — 404 is expected when no Stripe account exists yet
      }
    }
  };
}

export function clearPayoutStatus() {
  return (dispatch) => {
    dispatch(payoutStatusClear());
  };
}

export function fetchPayoutAccount() {
  return async (dispatch, getState) => {
    try {
      const { auth: { token } } = getState();
      dispatch(payoutAccountLoading(true));

      const response = await getPayoutAccountApi(token);
      const camelResponse = api.camelizeKeys(response);

      dispatch(payoutAccountLoaded(camelResponse));
      dispatch(payoutAccountLoading(false));
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(payoutAccountClear());
        dispatch(payoutAccountLoading(false));
        // No notice on failure, some accounts won't have access
      }
    }
  };
}

export function clearPayoutAccount() {
  return (dispatch) => {
    dispatch(payoutAccountClear());
  };
}

/**
 * Fetches stripe_account_country and stripe_account_type from products_data.
 * Returns { country, business_type } or null on failure.
 */
export function fetchPayoutBusinessInfo() {
  return async (dispatch, getState) => {
    try {
      const { auth: { token } } = getState();
      const response = await getPayoutBusinessInfoApi(token);
      const camelResponse = api.camelizeKeys(response);
      return camelResponse;
    } catch (e) {
      return null;
    }
  };
}

/**
 * Saves stripe_account_country and stripe_account_type to products_data.
 * Called from the Business Section on the Account page for manually-onboarded
 * clients who don't have an onboarding document.
 */
export function updatePayoutBusinessInfo(country, businessType, onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { auth: { token } } = getState();
      /* eslint-disable camelcase */
      await updatePayoutBusinessInfoApi({ country, business_type: businessType }, token);
      /* eslint-enable camelcase */
      dispatch(arriveNotice('Business info saved successfully.', 'ok'));
      if (onSuccess) onSuccess();
    } catch (e) {
      dispatch(arriveNotice(e.message));
    }
  };
}

/**
 * Fetches a short-lived client_secret from the backend.
 * Used by @stripe/react-connect-js to render the embedded onboarding form.
 * Returns { success, clientSecret } or { success: false, error }.
 */
export function fetchPayoutAccountSession() {
  return async (_dispatch, getState) => {
    try {
      const { auth: { token } } = getState();
      const response = await createPayoutAccountSessionApi(token);
      const camelResponse = api.camelizeKeys(response);
      return { success: true, clientSecret: camelResponse.clientSecret };
    } catch (e) {
      return { success: false, error: e.message };
    }
  };
}

/**
 * Permanently deletes the company's Stripe Express account.
 * Used when the company wants to unlink their payout details.
 */
export function deletePayoutAccountRequest(onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { auth: { token }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());

      await deletePayoutAccountApi(token);

      dispatch(payoutStatusClear());
      dispatch(payoutAccountClear());
      dispatch(arriveNotice('Payout account unlinked successfully.', 'ok'));
      dispatch(setSubmissionLoaderReset());
      if (onSuccess) onSuccess();
    } catch (e) {
      dispatch(setSubmissionLoaderReset());
      dispatch(arriveNotice(e.message));
    }
  };
}

// --- Agreement preview download ---
async function downloadAgreementPreviewApi(body) {
  const response = await api.post({
    path: 'common/customer-onboardings/preview-agreement',
    version: 'gateway',
    token: null,
    body,
    customError: true,
  });
  return response;
}

async function downloadPrefillAgreementPreviewApi(token) {
  const response = await api.get({
    path: `common/customer-onboardings/prefill/${token}/preview-agreement`,
    version: 'gateway',
    token: null,
    customError: true,
  });
  return response;
}

function triggerPdfDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadOnboardingAgreementPreview(payload) {
  return async (dispatch) => {
    try {
      const response = await downloadAgreementPreviewApi(payload);
      if (!response.ok) {
        const json = await response.json().catch(() => ({}));
        throw new Error(json.message || 'Could not generate agreement preview.');
      }
      const blob = await response.blob();
      triggerPdfDownload(blob, 'Redflag_Agreement_Preview.pdf');
    } catch (e) {
      dispatch(arriveNotice(e.message || 'Could not generate agreement preview.'));
    }
  };
}

export function downloadPrefillAgreementPreview(prefillToken) {
  return async (dispatch) => {
    try {
      const response = await downloadPrefillAgreementPreviewApi(prefillToken);
      if (!response.ok) {
        const json = await response.json().catch(() => ({}));
        throw new Error(json.message || 'Could not generate agreement preview.');
      }
      const blob = await response.blob();
      triggerPdfDownload(blob, 'Redflag_Agreement_Preview.pdf');
    } catch (e) {
      dispatch(arriveNotice(e.message || 'Could not generate agreement preview.'));
    }
  };
}
